import React from "react";
import image from '../../../images/situation/luikhoogte/luikhoogte.jpg'
import PropTypes from "prop-types";

Hoogte.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function Hoogte(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u invullen wat de hoogte van de luiken is, in milimeters.<br/>
        </div>
        <div className="phone-situation-description">
            Voorbeeld:<br/>
            Als uw luik 150 cm hoog is, voert u 1500 in als waarde.<br/>
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de luikhoogte in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}